<template>
  <!-- 处方模板列表页 -->
  <div class="prescription-wrapper">
    <div class="list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
    <div class="prescription-list" v-if="dataDone && scriptList.length > 0">
      <router-link tag="div" :to="{path: '/prescription-edit', query: {id: item.template_id, type: 'edit'}}" class="prescription-item" v-for="item in scriptList" :key="item.template_id">
        <div class="item-header">
          <h2 class="title">{{item.title}}</h2>
          <em>{{item.drug_type|formulationTypeFilter}}</em>
          <!-- <router-link class="edit-link">编辑</router-link> -->
        </div>
        <div class="prescription-content">{{item.scriptString}}</div>
      </router-link>
    </div>
    <div class="empty-data" v-if="dataDone && scriptList.length == 0">
      <icon icon-class="empty-template"></icon>
      <p>暂无处方模板</p>
    </div>
    <div class="add-prescription"><button class="add-button" @click="addPrescription">新增处方模板</button></div>
  </div>
</template>

<style lang="less" scoped>
  .prescription-wrapper{
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: #F7F7F7;
    .prescription-list{
      padding: 12px 16px 80px;
      .prescription-item{
        box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
        background-size: #FFF;
        border-radius: 6px;
        overflow: hidden;
        margin-bottom: 12px;
        .item-header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 48px;
          background: #FAFAFA;
          border-bottom: 1px solid #F3F3F3;
          position: relative;
           em{
             font-size: 13px;
             position: absolute;
             right: 13px;
             top:13px;
             color:#6f6f6f;
           }
          .title{
            position: relative;
            margin-left: 15px;
            padding-left: 19px;
            font-size: 15px;
            line-height: 18px;
            color: @black;
            max-width: 75%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: normal;
            &::after{
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              width: 4px;
              height: 16px;
              background: @xile;
              border-radius: 2px;
            }
          }
          .edit-link{
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            height: 100%;
            font-size: 14px;
            color: #666;
            cursor: pointer;
          }
        }
        .prescription-content{
          padding: 20px;
          font-size: 14px;
          line-height: 24px;
          color: #666;
          background: #FFF;
        }
      }
    }
    .add-prescription{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #F7F7F7;
      padding: 20px 16px;
      .add-button{
        @button-base();
        width: 100%;
        height: 40px;
        font-size: 14px;
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        scriptList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.$root.post('/getPreTmpList', {
        doc_id: this.userInfo.user_id,
        type:0
      }).then(data => {
        console.log(data);
        this.dataDone = true;
        if(data.length > 0) {
          // 处理处方内容为字符串
          data.forEach(item => {
            let list = [];
            item.content.forEach(herb => {
              let string = `${herb.name} ${herb.num}${herb.unit} ${herb.remark ? '(' + herb.remark + ')' : ''}`;
              list.push(string);
            })
            item.scriptString = list.join('、');
          })
        }
        this.scriptList = data || [];
      })
    },
    methods: {
      addPrescription() {
        this.$router.push('/prescription-edit');
      }
    },
    filters: {

      formulationTypeFilter(type) {
        switch (type) {
          case 1:
            return '中药饮片';
            break;
          case 2:
            return '配方颗粒';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Prescription/index.vue